import { useRef, useState } from 'react';

export default function useFieldTracker(
  initialValues: string[],
): [string[], (fieldName: string, value: boolean) => void] {
  const [fields, setFields] = useState<string[]>([...initialValues]);
  const fieldsSet = useRef<Set<string>>(new Set(initialValues));

  const onChange = (fieldName: string, shouldAdd: boolean): void => {
    fieldsSet.current[shouldAdd ? 'add' : 'delete'](fieldName);
    if (fieldsSet.current.size !== fields.length) {
      setFields(Array.from(fieldsSet.current));
    }
  };

  return [Array.from(fieldsSet.current), onChange];
}
